// @ts-ignore
export const base_path = window.base_path
// @ts-ignore
export const backend_url = window.backend_url
// @ts-ignore
export const protocol = window.http_protocol
